import { useLoaderData } from '@remix-run/react'
import dayjs from 'dayjs'
import { getContentfulAsset } from '~/libs/contentful/helpers'
import { PressPageLoaderData } from '~/routes/press._index'
import { TypePressReleaseArticles } from '~/types/contentful'

type TitleSectionProps = PressPageLoaderData & {
  articleData: TypePressReleaseArticles<'WITHOUT_UNRESOLVABLE_LINKS', string>
}

export default function TitleSection({ type = 'press' }) {
  const { pressPage, articleData } = useLoaderData() as TitleSectionProps
  const { pageTitle, headerImage } = pressPage?.fields || {}

  const image = getContentfulAsset(headerImage)
  if (type === 'press') {
    return (
      <div className="flex items-end relative overflow-clip h-fit my-0 mx-8 pt-10 bg-blue-10 rounded-2xl min-h-[280px] max-md:gap-3 max-md:mr-2 max-md:ml-4 max-md:min-h-60 max-md:rounded-[20px] max-lg:mx-6 max-lg:min-h-[260px]">
        <img
          className="absolute top-1/2 object-cover -translate-x-[8%] -translate-y-1/2 max-lg:-translate-x-[16%] max-md:-translate-x-1/4"
          src={image?.fields.file?.url}
          alt={image?.fields.title}
        />

        <h1
          className="text-left text-neutral-100 z-1 overflow-hidden m-[0_138px_40px_130px] text-2xl max-lg:m-[0_74px_44px_72px] max-md:m-[0_13px_48px_13px]"
          style={{
            display: '-webkit-box',
            WebkitLineClamp: 3,
            lineClamp: 3,
          }}
        >
          {pageTitle}
        </h1>
      </div>
    )
  } else {
    return (
      <div className="flex items-end relative overflow-clip h-fit my-0 mx-8 pt-10 bg-blue-10 rounded-2xl min-h-[280px] max-md:gap-3 max-md:mr-2 max-md:ml-4 max-md:min-h-60 max-md:rounded-[20px] max-lg:mx-6 max-lg:min-h-[260px]">
        <img
          className="absolute top-1/2 object-cover -translate-x-[8%] -translate-y-1/2 max-lg:-translate-x-[16%] max-md:-translate-x-1/4"
          src={image?.fields.file?.url}
          alt={image?.fields.title}
        />
        <div className="flex flex-col gap-4 items-center">
          <div className="flex gap-6 z-1 pl-30 items-center max-lg:pl-18 max-md:pl-4">
            <img
              className="object-contain w-fit h-5 max-w-25"
              src={articleData.fields?.brandLogo?.fields?.file?.url}
              alt={articleData.fields?.brandLogo?.fields?.title}
            />
            <p className="text-s text-neutral-60">
              {dayjs(articleData.fields?.datePublished).format('MMMM DD, YYYY')}
            </p>
          </div>
          <h1
            className="text-left text-neutral-100 z-1 overflow-hidden m-[0_138px_40px_130px] text-2xl max-lg:m-[0_74px_44px_72px] max-md:m-[0_13px_48px_13px]"
            style={{
              display: '-webkit-box',
              WebkitLineClamp: 3,
              lineClamp: 3,
            }}
          >
            {articleData.fields?.pageTitle}
          </h1>
        </div>
      </div>
    )
  }
}
